import { useTranslation } from 'react-i18next'
import { StyleSheet, View, ViewProps } from 'react-native'
import { Spacing } from 'zens-storybook'
import { Suspense, useRef } from 'react'
import { InsightTimeType } from 'zens-store'
import {
  useNumberParams,
  useParams,
  usePeriodParam,
  useWeekdaysParam,
  useWorkingHoursParam,
  useArrayParams,
} from 'zens-router'

import { GraphBar, InsightsHead, InsightsHeader, InsightsTime, InsightsTimeRef, LayoutHeader } from '@dms/component'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    margin: Spacing.L,
  },
  head: {
    zIndex: 100,
  },
})

interface Props extends ViewProps {}

const InsightsTimeScreen = (props: Props) => {
  const { style, ...otherProps } = props
  const { t } = useTranslation()
  const [{ companyId, buildingId, floorId, workspaceId }, setNumberParams] = useNumberParams()
  const [period] = usePeriodParam()
  const [weekdays] = useWeekdaysParam()
  const [workingHours] = useWorkingHoursParam()
  const [{ timeType }, setParams] = useParams()
  const [
    { bars },
    // setArrayParams
  ] = useArrayParams<GraphBar>()
  const insights = useRef<InsightsTimeRef>(null)

  // function updateGraphBars(bars: GraphBar[]) {
  //   setArrayParams({ bars })
  // }

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <Suspense fallback={<LayoutHeader.Skeleton breadcrumb title />}>
        <InsightsHeader companyId={companyId} buildingId={buildingId} breadcrumbItems={[{ title: t('Over time') }]} />
      </Suspense>
      <View style={styles.content}>
        <InsightsHead
          style={styles.head}
          companyId={companyId}
          buildingId={buildingId}
          downloadItems={[
            {
              key: 'data',
              icon: 'download',
              title: t('Download data'),
              testID: 'InsightsTime.DownloadData',
            },
            {
              key: 'graph',
              icon: 'download',
              title: t('Download graph'),
              testID: 'InsightsTime.DownloadGraph',
            },
          ]}
          onDownload={(key) => insights.current?.download(key)}
          href={(buildingId, floorId = 0) => ({
            pathname: `/companies/${companyId}/insights/${buildingId}/time`,
            params: { floorId },
          })}
        />
        <Suspense fallback={<InsightsTime.Skeleton />}>
          <InsightsTime
            ref={insights}
            companyId={companyId}
            buildingId={buildingId}
            floorId={floorId}
            period={period}
            weekdays={weekdays}
            workingHours={workingHours}
            type={timeType as InsightTimeType}
            onChangeType={(timeType) => setParams({ timeType })}
            workspaceId={workspaceId}
            onChangeWorkspaceId={(workspaceId) => setNumberParams({ workspaceId })}
            bars={bars}
            // onChangeBars={updateGraphBars}
          />
        </Suspense>
      </View>
    </View>
  )
}

export default InsightsTimeScreen
